export default __webpack_public_path__ + "static/media/tour-student.52f720af.svg";